import { render, staticRenderFns } from "./HeZhuOrderDetail.vue?vue&type=template&id=ee773b6e&scoped=true&"
import script from "./HeZhuOrderDetail.vue?vue&type=script&lang=js&"
export * from "./HeZhuOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./HeZhuOrderDetail.vue?vue&type=style&index=0&id=ee773b6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee773b6e",
  null
  
)

export default component.exports